import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { IntervalDate, UserPayrollTimeSheet } from '@wilson/interfaces';

@Injectable({
  providedIn: 'root',
})
export class UserPayrollTimeSheetsService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  getUserPayrollTimeSheets(userId: string, { start, end }: IntervalDate) {
    return this.httpClient.get<UserPayrollTimeSheet[]>(
      `${this.config.host}/user-payroll-time-sheets?where[userId]=${userId}&where[startDate]=${start}&where[endDate]=${end}`,
    );
  }
}
